import uiActions from './ui';
import { logger } from 'packages';
const actionTypes = {
    ADD: 'ITEMS/ADD',
    WISHLIST: 'ITEMS/WISHLIST',
    REMOVE_WISHLIST: 'ITEMS/REMOVE_WISHLIST'
};

const add = payload => ({
    type: actionTypes.ADD,
    payload
});

const wishlist = itemId => async (dispatch, getStore) => {
    const {
        initData: { isLoggedIn },
        items
    } = getStore();
    const redirectUrl = `${window.location.pathname}`;

    if (!isLoggedIn) {
        dispatch(uiActions.openSignInModal({ redirectUrl }));
        return;
    }
    const item = items[itemId];

    try {
        const existsInWishlist = item.existsInWishList;
        const url = existsInWishlist
            ? '/shopping/wishlist/remove'
            : '/shopping/wishlist/add';

        const response = await fetch(url, {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                itemId
            }),
            redirect: 'manual'
        });

        //just incase the user has logged out since we last got their profile information;
        // We don't care about the response for the ui, we just update the store regardless;
        if (response.type === 'opaqueredirect') {
            dispatch(uiActions.openSignInModal({ redirectUrl }));
            return;
        }

        dispatch({
            type: actionTypes.WISHLIST,
            payload: { itemId, exists: !existsInWishlist }
        });
    } catch (e) {
        logger(e, true);
    }
};

const removeWishList = payload => ({
    type: actionTypes.REMOVE_WISHLIST,
    payload
});

export default {
    add,
    wishlist,
    removeWishList,
    actionTypes
};



// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/state/actions/items.js